module.exports = __webpack_public_path__ + "img/qrimg.40c87750.png";